import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtm from '@gtm-support/vue2-gtm'
import store from '../store'
import NProgress from 'nprogress'
// import HomeView from '../views/HomeView'
// import NotFound from '../views/NotFound'
import i18n from '../i18n'
import Log from '@/utils/log'
const localeFiles = require.context('../locales/', false, /\.json$/)
const supportedLocales = []
localeFiles.keys().forEach((key) => {
  if (key === './index.js') return
  supportedLocales.push(key.replace(/(\.\/|\.json)/g, ''))
})

Vue.use(VueRouter)

function checkCardIdType (id) {
  const cards = store.getters['CARD/CARDS']
  const orders = store.getters['CARD/ORDERS']
  if (cards.filter(item => item.id === id).length) {
    return 'card'
  }
  if (orders.filter(item => item.id === id).length) {
    return 'order'
  }
  return ''
}

function setCardId (to, from, next) {
  // clear store card
  store.commit('CARD/SET_CARD_STATUS', {})
  const id = to.params.id
  Log(to.params)
  if (!id) {
    return { name: '404' }
  }
  Log(checkCardIdType(id))
  const type = checkCardIdType(id)
  if (!type) {
    store.commit('CARD/SET_CURRENT_ID', { id: '', type })
    return { name: '404' }
  }
  store.commit('CARD/SET_CURRENT_ID', { id, type })
  next()
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView')
  },
  {
    path: 'card',
    name: 'cardList',
    component: () => import('../views/CardList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'card/:id',
    name: 'cardDetail',
    component: () => import('../views/CardView.vue'),
    meta: { requiresAuth: true },
    beforeEnter: setCardId
  },
  {
    path: 'card/:id/topup',
    name: 'topup',
    component: () => import('../views/TopUpView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '404',
    name: '404',
    component: () => import('@/views/NotFound'),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
const localeRoutes = [
  // {
  //   path: '/',
  //   redirect: i18n.locale
  // },
  {
    path: `/:lang(${supportedLocales.join('|')})?`,
    component: {
      render (h) { return h('router-view') }
    },
    children: routes
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: localeRoutes,
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
})

if (process.env.VUE_APP_ENV === 'production') {
  Vue.use(VueGtm, {
    id: 'GTM-WKZ8P39', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    queryParams: process.env.VUE_APP_ENV === 'production'
      ? {
          gtm_auth: 'B0nYpxmzF9rQH4qoLwc9Cw',
          gtm_preview: 'env-1',
          gtm_cookies_win: 'x'
        }
      : {
          // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
          gtm_auth: 'wo8YXSxZj_pnzlWbU3GRxg',
          gtm_preview: 'env-10',
          gtm_cookies_win: 'x'
        },
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2726c7f26c', // Will add `nonce` to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
    trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
  })
}

router.beforeEach(async (to, from, next) => {
  // for case that when click previous page, close opening modals. Not sure if it impacts scenario that needs modal kept opened when changing pages
  store.dispatch('MODAL/CLOSE')
  NProgress.start()
  let lang = to.params.lang
  Log('to.params.lang', to.params.lang)
  // Log('beforeEnter', lang, !['zh-tw', 'zh-cn'].includes(lang))
  // 如果 URL 非 CHS、CHT 則導至瀏覽器預設語言
  // let localePath = null
  if (lang === undefined) {
    // localePath = 'en'
  }
  if (!supportedLocales.includes(lang)) {
    lang = 'en'
    // return next('/en')
  }

  // 如果 URL 有語系，則置換 i18n 語言
  if (lang && i18n.locale !== lang) {
    if (lang in i18n.messages) {
      store.commit('SET_LANG', lang)
      // router.replace({ name: router.currentRoute.name, params: { lang: lang } })
      //   .catch(() => {})
    } else {
      // lazy load locale json
      try {
        const res = await import(`@/locales/${lang}.json`)
        i18n.setLocaleMessage(lang, res)
        store.commit('SET_LANG', lang)
      } catch (e) {
        Log('e: ', e)
      }
    }
  }
  Log('localePath', lang)

  if (to.name === from.name) {
    Log('to.name === from.name', to.name === from.name)
    NProgress.done()
    return next()
  }

  const address = store.getters['WALLET/ADDRESS']
  if (to.meta.requiresAuth) {
    if (!address) {
      store.dispatch('WALLET/OPEN_WEB3MODAL')
      NProgress.done()
      Log('no address')
      return next({ name: 'home', params: { lang: lang } })
    }
    await store.dispatch('CARD/GET_CARDS')
    if (!store.getters['WALLET/IS_LOGIN']) {
      NProgress.done()
      return next({ name: 'home', params: { lang: lang } })
    }
  }
  NProgress.done()
  next()
})

export default router
